import React, { useEffect } from "react";
import { FileText } from "lucide-react";
import { useSnackbar } from "notistack";

import Button from "../../../componentsv2/Button";
import ModalPreviewAgendamentoPdf from "./ModalPreviewAgendamentoPdf";
import usePreviewAgendamentoPdf from "../data/hooks/usePreviewAgendamentoPdf";
import {
  baixarAgendamentoPdfUrl,
  buscarBlobAgendamentoPdf,
  buscarBlobAgendamentoPdfPreview,
  nomeArquivoAgendamentoPdf,
} from "../utils/agendamentoPdf";

export default function BotaoPdfAgendamento({
  label = "Visualizar PDF",
  tipoDocumento = "resumo",
  agendamentoId,
  versaoCache,
  obterPayload,
  disabled = false,
  variant = "contained",
  color = "blue",
}) {
  const { enqueueSnackbar } = useSnackbar();
  const preview = usePreviewAgendamentoPdf();
  const { invalidarCache } = preview;
  const modoPreview = Boolean(obterPayload);

  const opcoesArquivo = { agendamentoId, tipoDocumento };
  const cacheKey =
    agendamentoId && versaoCache != null ? `${agendamentoId}-${versaoCache}` : agendamentoId;

  useEffect(() => {
    if (versaoCache == null) return;
    invalidarCache();
  }, [versaoCache, invalidarCache]);

  const handleAbrirPdf = async () => {
    try {
      if (modoPreview) {
        const { payload, erro } = obterPayload();
        if (erro) {
          enqueueSnackbar(erro, { variant: "warning" });
          return;
        }

        await preview.abrirPreview({
          nomeArquivo: nomeArquivoAgendamentoPdf({ tipoDocumento }),
          carregarBlob: () => buscarBlobAgendamentoPdfPreview(payload),
          usarCache: false,
        });
        return;
      }

      if (!agendamentoId) {
        enqueueSnackbar("Agendamento não identificado.", { variant: "warning" });
        return;
      }

      await preview.abrirPreview({
        cacheKey,
        nomeArquivo: nomeArquivoAgendamentoPdf({ agendamentoId, tipoDocumento }),
        carregarBlob: () => buscarBlobAgendamentoPdf(agendamentoId),
        usarCache: true,
      });
    } catch (error) {
      enqueueSnackbar(
        error.response?.data?.messages || "Não foi possível gerar o PDF.",
        { variant: "error" }
      );
    }
  };

  const handleDownload = () => {
    if (!preview.blobUrl) return;
    baixarAgendamentoPdfUrl(preview.blobUrl, opcoesArquivo);
  };

  return (
    <>
      <Button
        type="button"
        color={color}
        variant={variant}
        disabled={disabled || preview.loading}
        onClick={handleAbrirPdf}
      >
        <FileText size={18} style={{ marginRight: 8 }} />
        {label}
      </Button>

      <ModalPreviewAgendamentoPdf
        open={preview.open}
        loading={preview.loading}
        nomeArquivo={preview.nomeArquivo}
        blobUrl={preview.blobUrl}
        onClose={preview.fecharPreview}
        onDownload={handleDownload}
      />
    </>
  );
}
